<template>
  <div class="body-wrapper">
    <div class="left-column">
      <div class="box">
        <div class="title-wrapper flex">
          <b class="title">Podaci o stanaru</b>
          <div class="icons-wrapper">
            <i
              class="fas fa-exclamation-triangle icon-notice"
              title="Pošaljite opomenu stanaru"
              v-if="member.balance < 0"
              @click="notifyModal = true"
            ></i>
            <i
              class="far fa-envelope icon-default"
              title="Pošaljite email stanaru"
              @click="processSendMailClick"
              v-if="shouldShowEmail"
            ></i>
            <i
              class="far fa-comment-dots icon-default"
              title="Pošaljite poruku stanaru"
              v-if="member.member_id != null && !isCurrentUser"
              @click="openChat"
            ></i>
            <i
              class="fas fa-user-check box-icon"
              title="Registrovani korisnik sa mobilnom aplikacijom"
              v-if="member.member_id != null"
            ></i>
            <i
              class="fas fa-user-plus box-icon invite-members-icon"
              title="Pošaljite pozivnicu za registraciju"
              v-if="member.member_id == null"
              @click="showInviteModal = true"
            ></i>
          </div>
        </div>
        <div class="info-box">
          <div class="left-column">
            <div class="div-description single-info">
              <small class="label">Broj stana</small>
              <h4 class="value">{{ member.div_description }}</h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Vlasnik</small>
              <h4 class="value">{{ member.full_name }}</h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Površina</small>
              <h4 class="value">
                {{ member.area_size == null ? '/' : member.area_size }} m2
              </h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Email</small>
              <h4 class="value">
                {{ member.email == null ? '/' : member.email }}
              </h4>
            </div>
            <div class="fullname single-info">
              <small class="label">Telefon</small>
              <h4 class="value">
                {{ member.phone_number == null ? '/' : member.phone_number }}
              </h4>
            </div>
          </div>
          <div class="right-column">
            <div
              class="single-info balance"
              :class="{
                positive: member.balance > 0,
                negative: member.balance < 0
              }"
            >
              <small class="label">Stanje (RSD)</small>
              <h2 class="value">{{ member.balance | addSeparator }}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="box invoices">
        <div class="title-wrapper">
          <b class="title">Računi</b>
        </div>
        <div class="table">
          <div class="labels row">
            <div class="column more" style="flex: 1"></div>
            <div
              class="column"
              v-for="column in invoices.columns"
              :key="column.key"
              :style="{ flex: column.flex }"
            >
              {{ column.label }}
            </div>
            <div class="column actions" style="flex: 4"></div>
          </div>

          <div v-if="invoices.data.length == 0">
            Ne postoje računi za korisnika
          </div>
          <div ref="rows" class="rows">
            <div
              class="row"
              v-for="(row, rowIndex) in invoices.data"
              :key="row.id"
              :class="{ expanded: row.isExpanded }"
            >
              <div class="parent">
                <div class="column more" style="flex: 1">
                  <a class="more-btn" @click="toggleItems(row)">
                    <i class="fas fa-chevron-right"></i>
                  </a>
                </div>
                <div
                  class="column"
                  v-for="column in invoices.columns"
                  :key="column.key"
                  :style="{ flex: column.flex }"
                >
                  {{ row[column.key] | addSeparator }}
                </div>
                <div class="column actions" style="flex: 4">
                  <a class="btn" @click="processMailClick(row.id)">
                    <i class="fas fa-envelope mail"></i>
                  </a>
                  <a class="btn" @click="downloadPdf(row, rowIndex)">
                    <spinner
                      :size="20"
                      line-fg-color="#00796b"
                      v-if="row.isLoading"
                    />
                    <i v-else class="fas fa-file-download"></i>
                  </a>
                </div>
              </div>
              <div class="items">
                <div class="row invoice-date">
                  <div class="column">{{ row.issueDate }}</div>
                </div>
                <div class="row">
                  <div class="column" style="flex: 1 1 0%">Rb.</div>
                  <div class="column" style="flex: 6 1 0%">Naziv</div>
                  <div class="column" style="flex: 2 1 0%">Kol.</div>
                  <div class="column" style="flex: 2 1 0%">Iznos (RSD)</div>
                </div>
                <div
                  class="row"
                  v-for="(itemRow, index) in row.invoiceItems"
                  :key="itemRow.id"
                >
                  <div class="column" style="flex: 1">{{ index + 1 }}.</div>
                  <div
                    class="column"
                    v-for="itemCol in invoices.itemsColumns"
                    :key="itemCol.key"
                    :style="{ flex: itemCol.flex }"
                  >
                    {{ itemRow[itemCol.key] | addSeparator }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-column">
      <div class="box transactions">
        <div class="title-wrapper">
          <b class="title">Transakcije</b>
        </div>
        <div class="table">
          <spinner
            class="spinner"
            line-fg-color="#00796b"
            :size="100"
            :line-size="6"
            v-if="loading"
          ></spinner>
          <div v-show="!loading" class="transactions-table">
            <data-table
              :columns="tableColumns"
              :tableData="tableData"
              :options="tableOptions"
              :slotTransactionsAmount="'amount'"
              :slotTransactionsBalance="'balance'"
            ></data-table>
          </div>
        </div>
      </div>
    </div>
    <modal-confirm-action
      v-if="showConfirmModal"
      @close="processConfirmModalClose"
      @confirm="processConfirmAction"
      :isLoading="confirmModalLoading"
      :title="confirmModalTitle"
      :error="confirmModalError"
      :errorMessage="confirmModalErrorMsg"
    >
      <div v-html="modalText"></div>
      <div v-if="modalType == 'sendEmail'">
        <input
          class="form-control email-subject"
          type="text"
          placeholder="Naslov"
          v-model="emailSubject"
        />
        <textarea
          rows="5"
          placeholder="Unesite sadržaj email-a"
          class="form-control"
          v-model="emailBody"
        ></textarea>
        <div class="upload-area">
          <upload-button
            class="upload-btn"
            @files-selected="getFiles"
            ref="uploadBtn"
          ></upload-button>
          <div class="uploaded">
            <div v-if="attachments.length == 0" class="no-files">
              <div class="upload-wrapper" @click="addFile">
                <svg
                  class="upload-icon pointer-cursor"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40"
                  height="33"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <label class="upload-text pointer-cursor"
                  >Izaberite datoteku</label
                >
              </div>
            </div>
            <div v-else>
              <div
                class="file"
                v-for="(file, index) of attachments"
                :key="index"
              >
                <p>{{ file.name }}</p>
                <i
                  class="fas fa-times del--mod"
                  @click="removeUploadedFile(index)"
                ></i>
              </div>
              <div
                class="email-upload-more-wrapper pointer-cursor"
                @click="addMoreFiles"
              >
                <svg
                  class
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 50 43"
                >
                  <path
                    d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"
                  />
                </svg>
                <span class>Dodaj datoteku</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal-confirm-action>
    <modal-confirm-action
      v-if="notifyModal"
      @close="processNotifyModalClose"
      @confirm="processNotifyModal"
      :error="noticeError"
      :isLoading="confirmModalLoading"
    >
      <checkbox
        :checked="sendMailNotice"
        label="Pošalji poslednji račun na email"
        @change="sendMailNotice = !sendMailNotice"
        v-if="shouldShowEmail"
      ></checkbox>
      <br />
      <checkbox
        :checked="downloadNotice"
        label="Štampaj poslednji račun za člana"
        @change="downloadNotice = !downloadNotice"
      ></checkbox>
    </modal-confirm-action>
    <modal-confirm-action
      v-if="showInviteModal"
      @close="showInviteModal = false"
      @confirm="handleInviteMember"
      :errorMessage="inviteErrorMessage"
      :isLoading="inviteLoading"
      title="Pozovite člana"
    >
      <div v-if="member.email">
        Da li ste sigurni da želite da pošaljete email na adresu
        <b>{{ member.email }}</b>
      </div>
      <div v-else>
        <p class="email-field">
          Email koji unesete biće sačuvan kao email korisnika.
        </p>
        <input
          type="email"
          class="form-control email-field"
          v-model="newEmail"
          placeholder="Email korisnika"
        />
      </div>
    </modal-confirm-action>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import { mapState, mapActions, mapMutations } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';
import checkbox from '@/components/common/Checkbox.vue';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  name: 'CommunityFinancesMember',
  components: {
    DataTable,
    modalConfirmAction,
    checkbox,
    uploadButton
  },
  mixins: [addSeparatorMixin],
  data() {
    return {
      modalConfirm: '',
      modalType: '',
      showConfirmModal: false,
      confirmModalLoading: false,
      confirmModalTitle: '',
      confirmModalError: false,
      confirmModalErrorMsg: '',
      showInviteModal: false,
      inviteErrorMessage: '',
      inviteLoading: false,
      newEmail: '',
      activeInvoiceId: '',
      emailBody: '',
      emailSubject: '',
      attachments: [],
      modalText: '',
      notifyModal: false,
      sendMailNotice: false,
      downloadNotice: false,
      member: {
        div_description: '',
        fullname: '',
        balance: 0
      },
      invoices: {
        columns: [
          { key: 'description', label: 'Opis', flex: 6 },
          { key: 'totalAmount', label: 'Iznos (RSD)', flex: 2 }
        ],
        itemsColumns: [
          { key: 'name', label: 'Opis', flex: 6 },
          { key: 'quantity', label: 'Kolicina', flex: 2 },
          { key: 'price', label: 'Cena', flex: 2 }
        ],
        data: [
          {
            description: 'desc',
            amount: '2040.20',
            isExpanded: false,
            invoiceItems: [
              {
                id: 1,
                description: 'Ciscenje',
                quantity: 1,
                price: 200
              },
              {
                id: 2,
                description: 'Kacenje rasvete',
                quantity: 1,
                price: 300
              }
            ]
          }
        ]
      },
      transactions: {
        columns: [
          { key: 'timestamp', label: 'Datum', flex: 3 },
          { key: 'amount', label: 'Iznos (RSD)', flex: 2 },
          { key: 'balance', label: 'Stanje (RSD)', flex: 2 }
        ]
      },
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      removingFile: false
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions']),
    noticeError() {
      return !this.downloadNotice && !this.sendMailNotice;
    },
    shouldShowEmail() {
      if (!this.member) return false;
      else {
        return this.member.member_id != null || this.member.email != '';
      }
    },
    isCurrentUser() {
      if (!this.member) return false;
      else {
        return (
          this.member.member_id ==
          this.$store.getters.getActiveCommunity.member_id
        );
      }
    }
  },
  created() {
    this.initTable('communityFinancesMemberTransactionsTable');
    financesInstance
      .get(`/members/${this.$route.params.memberId}`)
      .then(res => {
        this.member = res.data.member;
        if (this.member.member_id) {
          axios
            .post('/member/get-member-info', {
              member_id: this.member.member_id
            })
            .then(({ data }) => {
              const member = data.member;
              member.profile_pic_URL = data.media;
              member.user_full_name = data.user.full_name;
              member.communityId = data.member.community_id;
              member.communityName = `${
                this.$store.getters.getActiveCommunity.address
              } ${this.$store.getters.getActiveCommunity.street_number}`;
              this.$store.commit('setFictiveChat', member);
            });
        }
      })
      .catch(err => {});

    financesInstance
      .get(`/members/${this.$route.params.memberId}/invoices`)
      .then(res => {
        let data = res.data;

        for (let d of data) {
          d.isExpanded = false;
        }
        this.invoices.data = data;
        this.invoices.data.forEach(invoice => {
          invoice.issueDate = utilService.formatDate(invoice.issueDate);
          invoice.timestamp = utilService.formatDate(invoice.timestamp);
        });
      })
      .catch(err => {});

    financesInstance
      .get(`/members/${this.$route.params.memberId}/transactions`)
      .then(res => {
        const transactions = res.data.transactions;
        for (let t of transactions) {
          t.timestamp = utilService.formatDate(t.timestamp);
        }

        this.setTableData(res.data.transactions);
      })
      .catch(err => {
        console.log(err);
        this.setTableData([]);
      });
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', ['setTableBadge', 'setTableData']),
    ...mapMutations('modal', ['showModal']),
    ...mapActions('table', ['initTable']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    toggleItems(invoiceRow) {
      invoiceRow.isExpanded = !invoiceRow.isExpanded;
    },
    openChat() {
      this.$router.push({ name: 'inbox' });
    },
    removeUploadedFile(index) {
      this.removingFile = true;
      this.attachments.splice(index, 1);
    },
    getFiles(load) {
      for (let l of load) {
        this.attachments.push(l);
      }
    },
    async handleInviteMember() {
      this.inviteErrorMessage = '';
      if (this.member.email == '' && this.newEmail == '') {
        this.inviteErrorMessage = 'Morate uneti validan email';
        return;
      }
      if (!this.isEmailValid(this.newEmail)) {
        this.inviteErrorMessage = 'Morate uneti validan email';
        return;
      }
      try {
        this.inviteLoading = true;
        if (this.member.email) {
          await this.sendMailInvite();
        } else {
          await this.sendMailInvite(this.newEmail);
        }
      } catch (err) {
        console.log(err);
      }
    },
    isEmailValid(email) {
      return email == '' ? '' : this.reg.test(email) ? true : false;
    },
    addFile() {
      if (this.attachments.length > 0) {
        return;
      }
      if (this.removingFile) {
        this.removingFile = false;
        return;
      }
      this.$refs.uploadBtn.openFileSelect();
      return;
    },
    addMoreFiles() {
      this.$refs.uploadBtn.openFileSelect();
    },
    editEmail() {
      const virtualMember = {
        fullName: this.member.full_name,
        divDescription: this.member.div_description,
        email: this.newEmail
      };
      financesInstance
        .put(`members/${this.member.id}`, virtualMember)
        .then(() => {
          this.member.email = this.newEmail;
        })
        .catch(() => {});
    },
    processConfirmModalClose() {
      this.showConfirmModal = !this.showConfirmModal;
      this.confirmModalErrorMsg = '';
    },
    async processNotifyModal() {
      if (this.confirmModalLoading) {
        return;
      }
      this.confirmModalLoading = true;
      const invoiceId = this.invoices.data[0].id;
      if (this.sendMailNotice && !this.downloadNotice) {
        await this.sendEmail(this.invoices.data[0].id, this.member.id);
        this.notifyModal = false;
        this.confirmModalLoading = false;
      } else if (!this.sendMailNotice && this.downloadNotice) {
        await this.downloadPdf(this.invoices.data[0]);
        this.notifyModal = false;
        this.confirmModalLoading = false;
      } else {
        Promise.all([
          this.sendEmail(this.invoices.data[0].id, this.member.id),
          this.downloadPdf(this.invoices.data[0])
        ])
          .then(res => {
            this.showSuccessModal();
            this.notifyModal = false;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.confirmModalLoading = false;
          });
      }
    },
    processNotifyModalClose() {
      this.notifyModal = false;
      this.confirmModalErrorMsg = '';
    },
    processMailClick(invoiceId) {
      this.activeInvoiceId = invoiceId;
      this.confirmModalTitle = 'Pošaljite račun korisniku';

      this.modalText = `Da li ste sigurni da želite poslati račun na mail? `;
      if (this.member.email) {
        this.modalText += `<b>${this.member.email}</b>?`;
      }

      this.modalType = 'email';
      this.showConfirmModal = true;
    },
    processSendMailClick() {
      this.confirmModalTitle = 'Pošaljite email korisniku';
      this.modalType = 'sendEmail';
      this.showConfirmModal = true;
    },
    async processConfirmAction() {
      switch (this.modalType) {
        case 'email':
          this.confirmModalLoading = true;
          await this.sendEmail();
          break;
        case 'sendEmail':
          this.sendEmailToMember();
          break;
        default:
          return;
      }
    },
    async sendEmailToMember() {
      this.confirmModalError = false;
      this.confirmModalErrorMsg = '';

      if (this.emailBody == '') {
        this.confirmModalErrorMsg = 'Morate uneti sadržaj email-a.';
        return;
      }

      this.confirmModalLoading = true;
      financesInstance
        .post(
          `/members/${this.$route.params.memberId}/email`,
          this.formatMediaForSubmit(),
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then(() => {
          this.showSuccessModal();
          this.showConfirmModal = false;
          this.emailBody = '';
          this.emailSubject = '';
          this.attachments = [];
        })
        .catch(() => {
          this.showFailModal();
        })
        .finally(() => {
          this.confirmModalLoading = false;
        });
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      for (let i = 0; i < this.attachments.length; i++) {
        fd.append('attachments', this.attachments[i], this.attachments[i].name);
      }
      fd.append('emailBody', this.emailBody);
      fd.append('emailSubject', this.emailSubject);
      fd.append('to', this.member.email);
      return fd;
    },
    sendMailInvite(email = this.member.email) {
      axios
        .post('mail-invite/send-to-all', {
          community_id: this.$store.getters.getActiveCommunity.id,
          mail_list: [email]
        })
        .then(() => {
          this.showSuccessModal();
          this.inviteLoading = false;
          if (!this.member.email) {
            this.editEmail();
          }
          this.showInviteModal = false;
        })
        .catch(err => {
          this.showFailModal('Proverite unetu e-mail adresu');
          this.inviteLoading = false;
        });
    },
    sendEmail(invoiceId = this.activeInvoiceId, memberIds = this.member.id) {
      return financesInstance
        .post('/members/sendInvoiceToMail', {
          invoiceId: invoiceId,
          memberIds: memberIds
        })
        .then(res => {
          this.showSuccessModal();
          this.modalText = '';
          this.showConfirmModal = false;
        })
        .catch(err => {
          console.log(err);
          this.showFailModal();
        })
        .finally(() => {
          this.confirmModalLoading = false;
        });
    },
    downloadPdf(invoice, rowIndex) {
      const row = this.invoices.data[rowIndex];
      row.isLoading = true;
      this.invoices.data.splice(rowIndex, 1, row);
      return financesInstance
        .post(
          '/members/invoicesInPdf',
          {
            invoiceId: invoice.id,
            memberIds: [this.member.id]
          },
          {
            responseType: 'blob'
          }
        )
        .then(({ data }) => {
          var fileURL = window.URL.createObjectURL(new Blob([data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', invoice.description + '.pdf');
          document.body.appendChild(fileLink);

          fileLink.click();
          row.isLoading = false;
          this.invoices.data.splice(rowIndex, 1, row);
        })
        .catch(err => {
          row.isLoading = false;
          this.invoices.data.splice(rowIndex, 1, row);
          this.showFailModal();
        });
    }
  },
  destroyed() {
    //unsetting badge when view is closed
    //this.unsetTableData();
    // this.setTableBadge('');
  }
};
</script>
<style lang="scss">
.transactions-table {
  tr {
    cursor: default !important;
  }
}
</style>
<style lang="scss" scoped>
.transactions-table {
  tr {
    cursor: default !important;
  }
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 1;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 2;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 90%;
          flex-direction: column;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
        }

        &.expanded {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.flex {
  display: flex;
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
